import { useTranslation } from 'react-i18next';
import { SsoIntegration, SsoMappingField } from 'graphql-common';
import Chip, { ChipTypes } from '@lib/components/Chip/Chip';
import ClipboardCopy from '@lib/components/ClipboardCopy/ClipboardCopy';
import Typography from '@lib/components/Typography/Typography';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import AttributeMappingDisplay from './AttributeMappingDisplay';

interface Props {
  data?: SsoIntegration;
  supportedMappingFields?: SsoMappingField[];
}

export default function SsoConfigurationSection({
  data,
  supportedMappingFields,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={entityViewStyles.infoList}>
      <Typography variant="h3" className={entityViewStyles.infoListTitle}>
        {t('sso-configuration')}
      </Typography>
      <div className={entityViewStyles.infoItem}>
        <p className={entityViewStyles.infoItemLabelWithoutIcon}>
          <Typography variant="caption">{t('sso-code')}</Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          {data?.code ? (
            <ClipboardCopy copyText={data.code}>
              <Typography variant="body">{data.code}</Typography>
            </ClipboardCopy>
          ) : (
            <Typography variant="body">-</Typography>
          )}
        </div>
      </div>
      <div className={entityViewStyles.infoItem}>
        <p className={entityViewStyles.infoItemLabelWithoutIcon}>
          <Typography variant="caption">{t('attribute-mapping')}</Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          <AttributeMappingDisplay
            attributeMapping={data?.attributeMapping}
            supportedMappingFields={supportedMappingFields}
          />
        </div>
      </div>
      <div className={entityViewStyles.infoItem}>
        <p className={entityViewStyles.infoItemLabelWithoutIcon}>
          <Typography variant="caption">{t('jit-provisioning')}</Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          <Chip
            type={
              data?.jitProvisioningEnabled
                ? ChipTypes.chipGreen
                : ChipTypes.chipGray
            }
            label={data?.jitProvisioningEnabled ? t('enabled') : t('disabled')}
          />
        </div>
      </div>
      <div className={entityViewStyles.infoItem}>
        <p className={entityViewStyles.infoItemLabelWithoutIcon}>
          <Typography variant="caption">
            {t('clock-skew-tolerance-label')}
          </Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          <Typography variant="body">
            {data?.timeToleranceSeconds != null
              ? data.timeToleranceSeconds
              : '-'}
          </Typography>
        </div>
      </div>
    </div>
  );
}
